var BuyButton, MagicEventBus, resetMultiOptionLink;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

MagicEventBus = require('magic-event-bus/lib/frizzle.js');

BuyButton.View = require('../frontend/views/buy_button');

resetMultiOptionLink = function() {
  return $(window).on('pageshow', function() {
    var $wrapper, buyLink, linkWithNoQuantity;
    if ($('.multi-option-breakout').length) {
      $wrapper = '.multi-option-breakout';
      buyLink = $('#buy-link').attr('href');
    } else {
      $wrapper = '#options';
      buyLink = $('#options a.buy-button').attr('href');
    }
    if (!buyLink) {
      return;
    }
    linkWithNoQuantity = BuyButton.removeQuantityParam(buyLink);
    return $($wrapper + ' input[value="' + linkWithNoQuantity + '"]').prop('checked', true);
  });
};

BuyButton.removeQuantityParam = function(url) {
  return url.split(/&quantity=[0-9]+[^&]?/).join('');
};

BuyButton.init = function(arg, done) {
  var buyButton, goodsWarranty, handleBuyButton, iframeLogin, inlineVariations, variations;
  buyButton = arg.buyButton, iframeLogin = arg.iframeLogin, variations = arg.variations, inlineVariations = arg.inlineVariations, goodsWarranty = arg.goodsWarranty;
  this.eventBus = new MagicEventBus();
  if ((iframeLogin != null) && !iframeLogin.authenticated && !iframeLogin.disabledOnBuyButton) {
    handleBuyButton = function() {
      IframeLogin.openModal(BuyButton.view.$buyButton.attr('href'));
      return {
        stopTheBus: true
      };
    };
    this.eventBus.board('buy_button_clicked', handleBuyButton)(999);
  }
  return $((function(_this) {
    return function() {
      if (buyButton.multiOptionEnabled) {
        resetMultiOptionLink();
      }
      _this.view = new BuyButton.View({
        multiOptionEnabled: buyButton.multiOptionEnabled,
        multiOptionInline: buyButton.multiOptionInline,
        buyButtonEnabled: buyButton.buyButtonEnabled,
        hasVariations: (variations != null) || (inlineVariations != null),
        goodsWarranty: goodsWarranty
      });
      return done();
    };
  })(this));
};

module.exports = BuyButton;

//# sourceMappingURL=data:application/json;base64,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
